<section class="confirm">
  <div class="header">
    {{ title | translate }}
    <mat-icon *ngIf="showCloseButton" class="close-button" (click)="close()">close</mat-icon>
  </div>
  <div class="body">
    <div class="message confirm-dialog-html" *ngIf="html" [innerHTML]="html"></div>
    <span class="message" *ngIf="message">{{ message | translate }}</span>
  </div>
  <div class="footer">
    <button *ngIf="cancelButtonText && !isLoad" mat-button (click)="cancel()">
      {{ cancelButtonText | translate }}
    </button>

    <button mat-button class="btn-confirm" (click)="confirm()" *ngIf="!data.cbConfirm">
      <span>{{ confirmButtonText | translate }}</span>
    </button>
    <!-- customizacao para adicionar botão com spinner e disable action -->
    <div *ngIf="data.cbConfirm" class="cb" [class.isLoad]="isLoad">
      <div [innerText]="confirmButtonText | translate" (click)="confirm(true)" class="cb__button"></div>
      <mat-spinner [diameter]="30" color="primary" class="custom-spinner" *ngIf="isLoad"></mat-spinner>
    </div>
  </div>
</section>
